export const sizeWithGigabyteAbbreviationText = "aWb";
export const sizeWithMegabyteAbbreviationText = "bWb";
export const sizeWithKilobyteAbbreviationText = "cWb";
export const sizeWithByteAbbreviationText = "dWb";
export default {sizeWithGigabyteAbbreviationText,sizeWithMegabyteAbbreviationText,sizeWithKilobyteAbbreviationText,sizeWithByteAbbreviationText};